import { RECEIVE_SELF_EMPLOYMENT_PROFILE, REQUEST_SELF_EMPLOYMENT_PROFILE } from '../actions'

export default (
    state = {
        fetchSuccessful: null,
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_SELF_EMPLOYMENT_PROFILE:
            return { ...state, shouldFetch: false }

        case RECEIVE_SELF_EMPLOYMENT_PROFILE:
            return { ...state, ...data }

        default:
            return state
    }
}
